import type { ComponentPropsWithRef } from "react";
import { cn } from "@/utils/style.ts";

type Props = ComponentPropsWithRef<"div">;

export default function LinearLoader({ className, ...props }: Props) {
    return (
        <div
            role="progressbar"
            aria-busy="true"
            aria-valuemin={0}
            aria-valuemax={100}
            {...props}
            className={cn("linear-loader", className)}
        >
            <div className="linear-loader__bar" />
        </div>
    );
}
